import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { withTranslation } from "react-i18next";
import "antd/dist/antd.css";
import MessageBox from "./MessageBox";
import LoadingIndicator from "./LoadingIndicator";
import * as Helper from "../../utils/Helper";
import UIDs from "../../UIDs";
import axios from 'axios';
import { Pagination } from "antd";
import _ from "lodash";
const GOOGLE_SEARCH_CX = "000394246661141381640:sxzng__outw";
const GOOGLE_SEARCH_KAY = "AIzaSyC1QOJEtlOZyN6BMIMzRSUke371C3Fx0SA";
//unsplash
// import Unsplash, { toJson } from "unsplash-js";
// const unsplash = new Unsplash({
//   accessKey: "qjxeMtiExGc91m7Twkl6y4qnhThTVa22ZvzEo6A6QQw",
// });

const uid = UIDs.components.ui.searchimageonline;
//google
const pageSize = 10;
const SearchImageOnline = (props) => {

    //componentDidMount() {
        // (function () {
        //     const cx = "000888210889775888983:g9ckaktfipe";
        //     const gcse = document.createElement("script");
        //     gcse.type = "text/javascript";
        //     gcse.async = true;
        //     gcse.src = `https://cse.google.com/cse.js?cx=${cx}`;
        //     const s = document.getElementsByTagName("script")[0];
        //     s.parentNode.insertBefore(gcse, s);
        // })();

        // (function () {
        //     var renderSearchForms = function () {
        //         if (document.readyState === "complete") {
        //             window.google.search.cse.element.render({
        //                 div: "searchResult",
        //                 tag: "search",
        //                 gname: "gsearch",
        //             });
        //         } else {
        //             window.google.setOnLoadCallback(function () {
        //                 window.google.search.cse.element.render({
        //                     div: "searchResult",
        //                     tag: "search",
        //                     gname: "gsearch",
        //                 });
        //             }, true);
        //         }
        //     };

        //     window.__gcse = {
        //         parsetags: "explicit",
        //         callback: renderSearchForms,
        //     };
        // })();
    //}
    const [loading, setLoading] = useState(false);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [photos, setPhotos] = useState([]);
    const [page, setPage] = useState(1);
    const [txtInput, setTxtInput] = useState("");
    const [searchResult, setSearchResult] = useState({});

    const fetchImagesByGoogle = async (passedPage) => {
        //only fetch google images when changes query string
        await axios.get("https://www.googleapis.com/customsearch/v1", {
            params: {
                key: GOOGLE_SEARCH_KAY,
                cx: GOOGLE_SEARCH_CX,
                q: txtInput,
                num: pageSize,
                start: passedPage <= 1 ? 1 : (passedPage - 1) * pageSize + 1,
                searchType: "image",
                imgType: "photo",
                imgSize: "small",
            },
        }).then((res) => {
            if (res && res.data) {
                setSearchResult(() => {
                    if (txtInput && res.data && res.data.searchInformation) {
                        let searchResult = { totalCount: _.parseInt(res.data.searchInformation.totalResults, 10), totalCountStr: res.data.searchInformation.formattedTotalResults, searchTime: res.data.searchInformation.formattedSearchTime };
                        return searchResult;
                    }
                });
                setPhotos(() => {
                    if (txtInput && res.data && res.data.items) {
                        return res.data.items;
                    }
                });
            }
        }).catch(err => {
            MessageBox.danger({ text: err.toString() });
        });
        setLoading(false);
    };

    const handleSearch = (page) => {
        if (txtInput) {
            setLoading(true);
            setPage(page);
            fetchImagesByGoogle(page);
            //fetchImagesByUnsplash();
            //fetchImageByBaidu();
        }
    };

    // const fetchImagesByUnsplash = async () => {
    //     unsplash.search
    //         .photos(query)
    //         .then(toJson)
    //         .then((json) => {
    //             setLoading(false);
    //             setPhotos(json.results);
    //         }).catch(err => {
    //             console.log(err);
    //         });
    // };
    
    const showSearchImageArea = () => {
        setShowSearchModal(!showSearchModal);
    };

    const handleInputSearch = (e) => {
        e.preventDefault();
        setTxtInput(e.target.value);
    };

    const handleChooseImage = (path) => {
        axios.get(path, {
            responseType: 'blob',
        })
        .then((res) => {
                let names = path.split("/");
                let name = names[names.length - 1];
                if(name.indexOf("?")>0) name = name.substr(name, name.indexOf("?"));
                let file = new File([res.data], name);
                props.startUpload(file, "1", props.uploadSuccessCallback);
        }).catch(err => {
                MessageBox.danger({text: err.toString()});
        });
        setShowSearchModal(false);
    };

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            handleSearch(1);
        }
    };

    const handleCancelSearch = () => {
        setTxtInput("");
        setPhotos("");
        setSearchResult({});
        setPage(1);
        setShowSearchModal(false);
    };

    return (
        <div style={{ display: 'flex', height: 100 }}>
            <div style={{ display: 'flex', flex: 1 }}>
                <div style={{ flex: 1 }}>
                    <div className="SearchImageDiv" >
                        <div style={styles.fakeDiv} onClick={() => showSearchImageArea()}>
                            <div>
                                <i className="fa fa-search" style={{fontSize:"30px", marginTop:"5px"}}></i>
                                <div className="search-font">{props.t("clickToSearchImage")}</div>
                            </div>
                        </div>
                        <Modal isOpen={showSearchModal} style={{ maxWidth: "80%" }}>
                            <ModalBody>
                                <div className="searchInputs" >
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ float: "left", width: "76%" }}
                                        placeholder={props.t("searchHere")}
                                        value={txtInput}
                                        onKeyDown ={(e) => handleKeyPress(e)}
                                        onChange={handleInputSearch}
                                    />
                                    <Button color="primary" style={{ marginLeft: "15px", marginTop:"2px" }} onClick={() => handleSearch(1)}>{props.t("searchImage")}</Button>
                                    <Button color="default" style={{ marginLeft: "5px", marginTop:"2px" }} onClick={() => handleCancelSearch()}>{props.t("cancel")}</Button>
                                </div>
                                <div id="searchResult" className="searchResult" style={{ clear: "both" }}>
                                    {searchResult && searchResult.totalCountStr && <div style={{paddingTop:"10px", paddingBottom:"10px"}}>
                                        <span>{props.t("searchTime", { time: searchResult.searchTime })}  --  {props.t("total", { totalNum: searchResult.totalCountStr })}</span>
                                    </div>}
                                    <div style={{ ...styles.cardList }}>
                                        {photos && photos.map((pic, index) => (
                                            <div key={index} onClick={() => handleChooseImage(pic.link)}>
                                                <img
                                                    style={{ ...styles.cardImage }}
                                                    alt={pic.title}
                                                    src={pic.link}
                                                    width="50%"
                                                    height="auto"
                                                ></img>
                                            </div>
                                        ))}{" "}
                                    </div>
                                    {searchResult && searchResult.totalCount && <Pagination
                                        style={{paddingTop: "10px"}}
                                        defaultCurrent={1}
                                        current={page}
                                        total={100}
                                        defaultPageSize={pageSize}
                                        showTotal={total => props.t("total", { totalNum: 100 })}
                                        onChange={(page) => {
                                            handleSearch(page);
                                        }}
                                        //simple={true}
                                    />}
                                </div>
                                
                                {loading && <LoadingIndicator />}
                                {/* <div className="gcse-searchbox" data-newWimdow="false"/> */}
                            </ModalBody>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    cardImage: {
        flex: "100%",
        marginTop: "1rem",
        borderRadius: "10px",
    },
    cardList: {
        columnCount: 5,
    },
    fakeDiv: {
        position: "relative",
        width: "200px",
        textAlign: "center",
        background: "#fafafa",
        border: "1px dashed #d9d9d9",
        borderRadius: "4px",
        cursor: "pointer",
        transition:"border-color 0.3s",
        height: "74px",
        padding: "5px",
    }
}

export default withTranslation(uid)(SearchImageOnline);
